module.exports = __webpack_public_path__ + "static/media/chevron-double-right.5686308d.svg";